import React from 'react';
import classNames from 'classnames';
import Typography, { Variant } from '@lib/components/Typography/Typography';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import styles from './FieldTitleRender.module.scss';

interface FieldTitleRenderProps {
  hasBottomSpace?: boolean;
  isBlockStart?: boolean;
  rightSlot?: React.ReactNode;
  strong?: boolean;
  title: string;
  tooltipText?: React.ReactNode;
  variant?: Variant;
}

export default function FieldTitleRender({
  hasBottomSpace = false,
  isBlockStart = false,
  rightSlot,
  strong = false,
  title,
  tooltipText,
  variant = 'h3',
}: FieldTitleRenderProps) {
  return (
    <div
      className={classNames(
        styles.fieldTitle,
        isBlockStart && styles.blockStart,
        hasBottomSpace && styles.bottomSpace,
      )}
    >
      <Typography variant={variant} strong={strong}>
        {title}
      </Typography>
      {tooltipText && (
        <div className={styles.fieldTitleIcon}>
          <Tooltip body={tooltipText}>
            <MaterialIcon
              cursor="help"
              icon="info"
              symbolsOutlined
              size="md-16"
            />
          </Tooltip>
        </div>
      )}
      {rightSlot && <div className={styles.fieldTitleIcon}>{rightSlot}</div>}
    </div>
  );
}
